import http from "./request/http";
import webim from "./utils/plugin/webim";
import cookies from 'vue-cookies'
import toast from 'vue2-toast'
import main from './main'
import wx from 'weixin-js-sdk'
function getUrlKey(name) {//获取url 参数
  // alert("location.href code = "+"====="+location.href);
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
}
export default {
  login(){
    let origin =  location.href;
    let urlNow = encodeURIComponent(origin);
    let scope = 'snsapi_userinfo';
    let appid = process.env.APP_ID;
    let state = 123;
    let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${urlNow}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`
    let code = getUrlKey('code');
    let orderid = getUrlKey('orderid')?getUrlKey('orderid'):'';
    console.log(cookies.get('app_token'));
      if(code == null || code === ''){
        window.location.href = url;
      }else{
        http.post('/api/wap/public/wxmsg',{
          code:code,
          order_id:orderid
        }).then(res=>{
          console.log(res)

          if(res.errno == 0){
            cookies.set('app_token', res.data.unionid);
            cookies.set('openid', res.data.openid);
            cookies.set('avatar', res.data.avatar);

            main.v1.$imConn.open({
              apiUrl: WebIM.config.apiURL,
              user: res.data.unionid,
              pwd:'dy123456app',
              appKey: WebIM.config.appkey,
              success:function (res) {
                console.log(res)
                cookies.set('accessToken',res.access_token)
                http.get('/api/wap/public/wxaddress',{
                  url: window.location.href //'http://xl.dev.dayiketang.com/' //
                }).then(res=> {
                  console.log(res)
                  wx.config({
                    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来
                    appId: res.data.appId, // 必填，公众号的唯一标识
                    timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                    nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
                    signature: res.data.signature,// 必填，签名，见附录1
                    jsApiList: [
                      "getLocation"
                    ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                  });
                  wx.ready(function () {
                    // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
                    wx.getLocation({
                      type: 'wgs64',
                      success: res => {
                        console.log(res)
                        http.post('/api/wap/public/wxaddress',{
                          lon:res.longitude,
                          lat:res.latitude
                        }).then(res=>{
                          console.log(res)
                        })
                      }
                    })
                  });
                });
              }
            });
            //location.reload();

          }else{
            main.v1.$toast.center(res.errmsg)
          }
        })
      }

  }
}



// WEBPACK FOOTER //
// ./src/login.js